import { Config, CognitoIdentityCredentials } from 'aws-sdk'
import { CognitoUserPool, CognitoUser, AuthenticationDetails, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import store from '../store'
export default class CognitoAuth {
  // Tutorial2
  configure (config) {
    if (config.userPool) {
      // console.log('SignUp')
      this.userPool = config.userPool
    } else {
      // console.log('SignUp')
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId,
      })
    }
    Config.region = config.region
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId,
    })

    this.options = config
    this.currentUser = false
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, '$cognito', {
      get () { return this.$root._cognito },
    })

    Vue.mixin({
      beforeCreate () {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito
          this._cognito.configure(options)
        }
      },
    })
  }

  signUp (email, password, userRole, phone) {
    const attributeList = []
    attributeList.push(new CognitoUserAttribute({ Name: 'email', Value: email }))
    attributeList.push(new CognitoUserAttribute({ Name: 'custom:role', Value: userRole }))
    attributeList.push(new CognitoUserAttribute({ Name: 'custom:phone', Value: phone }))
    console.log(attributeList)
    return new Promise((resolve, reject) => {
      this.userPool.signUp(email, password, attributeList, null, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  confirmation (username, confirmationCode) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  signin (username, password) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    const authenticationData = { Username: username, Password: password }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          resolve(result)
        },
        onFailure: (err) => {
          // console.log(err)
          reject(err)
        },
        mfaRequired: function(codeDeliveryDetails) {
          var verificationCode = prompt('Por favor, ingresa el código de autentificación MFA', '')
          cognitoUser.sendMFACode(verificationCode, this)
        },
        newPasswordRequired: function(userAttributes, requiredAttributes) {
          console.log(userAttributes)
          console.log(requiredAttributes)
          const newPassword = prompt('Por favor, ingresa tu nueva contraseña. Recuerda que: La contraseña debe tener 8 caracteres como mínimo. Incluye letras mayúsculas, letras minúsculas, números y caracteres especiales. ', '')
          cognitoUser.completeNewPasswordChallenge(newPassword, null, this)
          //  resolve({ new_password_required: true, cognitoUser: cognitoUser })
        },
      })
    })
  }

  signout () {
    if (this.userPool.getCurrentUser()) {
      // console.log(this.userPool.getCurrentUser())
      this.userPool.getCurrentUser().signOut()
    }
  }

  isAuthenticated () {
    this.currentUser = this.userPool.getCurrentUser()
    return new Promise((resolve, reject) => {
      if (this.currentUser === null) { reject(this.currentUser) }
      this.currentUser.getSession((err, session) => {
        if (err) {
          reject(err)
        } else {
          if (!session.isValid()) {
            reject(session)
          } else {
            resolve(session)
          }
        }
      })
    })
  }

  getAttribute () {
    return new Promise((resolve, reject) => {
      this.currentUser.getUserAttributes((err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  resentCode () {
    return new Promise((resolve, reject) => {
      this.currentUser.getAttributeVerificationCode('email', {
        onSuccess: (result) => {
          console.log('success getAttributeVerificationCode')
          resolve(result)
        },
        onFailure: (err) => {
          console.log('failed getAttributeVerificationCode: ' + JSON.stringify(err))
          reject(err)
        },
      })
    })
  }

  verifyAttribute (confirmationCode) {
    return new Promise((resolve, reject) => {
      this.currentUser.verifyAttribute('email', confirmationCode, {
        onSuccess: (result) => {
          console.log('email verification success')
          var user = store.getters.user
          user.email_verified = 'true'
          store.commit('setUser', user)
          resolve(result)
        },
        onFailure: (err) => {
          console.log('email verification failed')
          reject(err)
        },
      })
    })
  }

  updateEmailAddress (email) {
    const attributes = {
      email: email,
      name: email,
    }
    return new Promise((resolve, reject) => {
      this.updateAttributes(attributes)
        .then(result => { // eslint-disable-line
          resolve(result)
          var user = store.getters.user
          user.email_verified = 'false'
          store.commit('setUser', user)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  updatePassword(oldPassword, newPassword) {
    return new Promise((resolve, reject) => {
      this.currentUser.changePassword(oldPassword, newPassword, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }

  forgetPassword(username) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess: (result) => {
          console.log('email verification success')
          resolve(result)
        },
        onFailure: (err) => {
          console.log('email verification failed')
          reject(err)
        },
      })
    })
  }

  resetPassword(username, newPassword, code) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(code, newPassword, {
        onSuccess: (result) => {
          console.log('password reset success')
          resolve(result)
        },
        onFailure: (err) => {
          console.log('password reset failed')
          reject(err)
        },
      })
    })
  }

  updateAttributes (attributes) {
    const attributeList = []
    for (var key in attributes) {
      const attribute = { Name: key, Value: attributes[key] }
      attributeList.push(new CognitoUserAttribute(attribute))
    }
    return new Promise((resolve, reject) => {
      if (this.currentUser === null) { reject(this.currentUser) }

      // update attributes
      this.currentUser.updateAttributes(attributeList, (err, result) => {
        if (err) {
          reject(err)
        } else {
          var user = store.getters.user
          for (var key in attributes) {
            user[key] = attributes[key]
          }
          store.commit('setUser', user)
          resolve(result)
        }
      })
    })
  }

  /*
  constructor() {
    this.userSession = null
  }

  isAuthenticated(cb) {
    const cognitoUser = this.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          return cb(err, false)
        }
        return cb(err, false)
      })
    } else {
      cb(null, false)
    }
  }

  signup(username, email, pass, cb) {
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email,
      }),
    ]
    this.userPoll.signup(username, pass, attributeList, null, cb)
  }

  authenticate(username, pass, cb) {
    const authenticationData = { Username: username, Password: pass }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        console.log('access token + ' + result.getAccessToken.getJwtToken())
        var logins = {}
        logins['cognito-idp.' + this.options.region + '.amazonaws.com/' + this.options.UserPoolId] = result.getIdToken().getJwtToken()
        console.log(logins)

        Config.credentials = new CognitoIdentityCredentials({
          IdentityPoolId: this.options.UserPoolId,
          Logins: logins,
        })
        console.log(Config.credentials)
        this.onChange(true)
        cb(null, result)
      },
      onFailure: function (err) {
        cb(err)
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        console.log('New PAssword is required')
      },
    })
  }

  getCurrentUser() {
    return this.userPool.getCurrentUser()
  }

  confirmRegistration(username, code, cb) {
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool,
    })
    cognitoUser.confirmRegistration(code, true, cb)
  }

  logout() {
    this.getCurrentUser.signOut()
  }

  getIdToken(cb) {
    if (this.getCurrentUser() == null) {
      return cb(null, null)
    }
    this.getCurrentUser().getSession((err, session) => {
      if (err) return cb(err)
      if (session.isValid()) {
        return cb(null, session.getIdToken().getJwtToken())
      }
      cb(Error('Session is invalid'))
    })
  }
  */
}
